<script setup lang="ts">
import { EntityListPage, type EntityConfig } from '@botto/core';
import { operatorsStore } from '../api';
import type { Operator } from '../api';

const config: EntityConfig<Operator> = {
  title: 'Оператор',
  titlePlural: 'Операторы',
  popupWidth: 520,
  columns: [
    { dataField: 'id', caption: 'ID', dataType: 'number', width: 80 },
    { dataField: 'operator', caption: 'Оператор' },
    { dataField: 'mnc', caption: 'MNC', width: 100 },
    { dataField: 'description', caption: 'Описание' },
  ],
  fields: [
    { dataField: 'id', label: 'ID', editOnly: true, editorOptions: { readOnly: true } },
    { dataField: 'operator', label: 'Название', required: true },
    { dataField: 'mnc', label: 'MNC', required: true },
    { dataField: 'description', label: 'Описание', editorType: 'dxTextArea' },
  ],
};
</script>

<template>
  <EntityListPage :config="config" :store="operatorsStore" />
</template>
